import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsInvalidNumberOfBricks extends AnnualPeriodsError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks is not a number', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default AnnualPeriodsInvalidNumberOfBricks;
